import React, { Component } from 'react'
import TimeLine from "react-gantt-timeline";


import produce from "immer"
import View from 'react-flexbox'
const traducao = {
    id: "uid",
    start: "dataInicio",
    end: "dataFimPrevista1",
    name: "titulo",
    color: "corGant",
}

const config = {
    taskList: {
        task: {
            style: {
                backgroundColor: "grey",
                color: "white"
            },
            renderItem: (item) => "oi kk"
        }

    }
};
export default class GantComponent extends Component {
    constructor(props) {
        super(props);
        this.updateItem = this.updateItem.bind(this)
        let d1 = new Date();
        let d2 = new Date();
        d2.setDate(d2.getDate() + 5);
        let d3 = new Date();
        d3.setDate(d3.getDate() + 8);
        let d4 = new Date();
        d4.setDate(d4.getDate() + 20);

        let data = [
            {
                id: 1,
                start: d1,
                end: d2,
                name: "Demo Task 1"
            },
            {
                id: 2,
                start: d3,
                end: d4,
                name: "Demo Task 2",
                color: "orange"
            }
        ];

        this.state = { data: data, links: [] };
    }

    componentDidMount() {
        if (this.props.customFormInterno)
            this.props.listar(this.props.customFormInterno);
    }
    genID() {
        function S4() {
            return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
        }
        return (
            S4() +
            S4() +
            "-" +
            S4() +
            "-4" +
            S4().substr(0, 3) +
            "-" +
            S4() +
            "-" +
            S4() +
            S4() +
            S4()
        ).toLowerCase();
    }
    createLink(start, end) {
        return {
            id: this.genID(),
            start: start.task.id,
            startPosition: start.position,
            end: end.task.id,
            endPosition: end.position
        };
    }
    onUpdateTask = (item, props) => {


        item.start = props.start;
        item.end = props.end;
        // console.log('item', item);

        // this.setState({ data: [...this.state.data] });
        this.updateItem(item)
    };
    onCreateLink = item => {
        let newLink = this.createLink(item.start, item.end);
        alert("Nao implementado")
        // this.setState({ links: [...this.state.links, newLink] });
    };

    updateItem(item) {
        console.log('item', item);

        // const { lista } = this.props;
        // const nextState = produce({ value: lista || [] }, draftState => {
        //     draftState.value.forEach(element => {
        //         if (element[traducao.id] === item.id) {
        //             element[traducao.start] = item.start
        //             element[traducao.end] = item.end
        //             element[traducao.name] = item.name
        //             element[traducao.color] = item.color
        //             console.log('element', element);

        //         }
        //     });

        // })

        let tk = item.original;
        tk[traducao.start] = item.start
        tk[traducao.end] = item.end
        tk[traducao.name] = item.name

        this.props.salvarItem(this.props.customFormInterno, tk)

        // onChange(nextState.value);
    }
    // getRandomColor() {
    //     var letters = "0123456789ABCDEF";
    //     var color = "#";
    //     for (var i = 0; i < 6; i++) {
    //         color += letters[Math.floor(Math.random() * 16)];
    //     }
    //     return color
    // }
    calcFim(item, inicio) {
        let hojeFim = new Date();
        hojeFim.setDate(inicio.getDate() + 1);
        return hojeFim;
    }
    render() {
        const { lista } = this.props;
        let hoje = new Date();
        let hojeFim = new Date();
        hojeFim.setDate(hojeFim.getDate() + 1);
        let array = lista ? lista.map(item => {
            let id = item[traducao.id]
            let name = item[traducao.name]
            let color = "#c2c2c2"
            let start = null
            let end = null
            if (item[traducao.start]) {
                try {

                    start = item[traducao.start].toDate()
                } catch (error) {
                    start = item[traducao.start]

                }
            }
            if (item[traducao.end]) {
                try {

                    end = item[traducao.end].toDate()
                } catch (error) {
                    end = item[traducao.end]

                }
            }


            if (!start) {
                start = hoje
            }

            if (!end) {
                end = this.calcFim(item, item[traducao.start] || hoje)
            }
            return {
                original: item,
                id: id,
                name: name,
                color: color,
                start: start,
                end: end,

            }
        }) : []
        var tasks = [
            {
                id: 'Task 1',
                name: 'Redesign website',
                start: '2016-12-28',
                end: '2016-12-31',
                progress: 20,
                dependencies: 'Task 2, Task 3',
                custom_class: 'bar-milestone' // optional
            },
        ]
        return (
            <View style={{ width: 0, }}>
                <TimeLine
                    data={array}
                    links={this.state.links}
                    onUpdateTask={this.onUpdateTask}
                    onCreateLink={this.onCreateLink}
                    config={config}
                />
                {/* <ReactGantt
                    tasks={tasks}
                    viewMode={"Month"}
                    onClick={(acao) => console.log('acao', acao)}
                    onDateChange={(acao) => console.log('acao2', acao)}
                    onProgressChange={(acao) => console.log('acao3', acao)}
                    onViewChange={(acao) => console.log('acao4', acao)}
                    customPopupHtml={(acao) => console.log('acao5', acao)}
                /> */}
            </View>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/GantListaFiltrada/components/GantComponent/GantComponent.js